import {
  FETCH_BOOKINGS,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILED,
  UPDATE_BOOKING,
  CANCEL_BOOKING
} from "../store/types";
import { fetchBookingLocations } from '../actions/locationactions';
import { RequestPushMsg } from '../other/NotificationFunctions';
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { addActualsToBooking, saveAddresses, updateDriverQueue } from "../other/sharedFunctions";
import { get, onValue, update, off, remove, push, runTransaction } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";

export const fetchBookings = () => (dispatch) => {

  const {
    bookingListRef,
  } = firebase;

  dispatch({
    type: FETCH_BOOKINGS,
    payload: null,
  });

  const userInfo = store.getState().auth.profile;
  
  if (!userInfo || !userInfo.uid || !userInfo.usertype) {
    dispatch({
      type: FETCH_BOOKINGS_FAILED,
      payload: "User info not available",
    });
    return;
  }

  off(bookingListRef(userInfo.uid, userInfo.usertype));
  console.log('fetchBookings: Listening for bookings - uid:', userInfo.uid, 'usertype:', userInfo.usertype);
  onValue(bookingListRef(userInfo.uid, userInfo.usertype),(snapshot) => {
    console.log('fetchBookings: onValue triggered, snapshot exists:', snapshot.val() ? true : false);
    if (snapshot.val()) {
      const data = snapshot.val();
      console.log('fetchBookings: Found', Object.keys(data).length, 'bookings');
      const active = [];
      let tracked = null;
      const bookings = Object.keys(data)
        .map((i) => {
          data[i].id = i;
          data[i].pickupAddress = data[i].pickup && data[i].pickup.add ? data[i].pickup.add : '';
          data[i].dropAddress = data[i].drop && data[i].drop.add ? data[i].drop.add : '';
          data[i].discount = data[i].discount ? data[i].discount : 0;
          data[i].cashPaymentAmount = data[i].cashPaymentAmount ? data[i].cashPaymentAmount : 0;
          data[i].cardPaymentAmount = data[i].cardPaymentAmount ? data[i].cardPaymentAmount : 0;
          return data[i];
        });
      console.log('fetchBookings: Mapped bookings:', bookings.map(b => ({id: b.id, status: b.status})));
      for (let i = 0; i < bookings.length; i++) {
        if (bookings[i] && bookings[i].status && ['PAYMENT_PENDING','NEW', 'ACCEPTED', 'ARRIVED', 'STARTED', 'REACHED', 'PENDING', 'PAID'].indexOf(bookings[i].status) != -1) {
          active.push(bookings[i]);
        }
        if (bookings[i] && bookings[i].status && (['ACCEPTED', 'ARRIVED', 'STARTED'].indexOf(bookings[i].status) != -1) && userInfo && userInfo.usertype == 'driver') {
          tracked = bookings[i];
          if (tracked && tracked.id) {
            fetchBookingLocations(tracked.id)(dispatch);
          }
        }
      }
      console.log('fetchBookings: Active bookings count:', active.length);
      console.log('fetchBookings: Active bookings:', active.map(b => ({id: b.id, status: b.status})));
      dispatch({
        type: FETCH_BOOKINGS_SUCCESS,
        payload: {
          bookings: bookings.reverse(),
          active: active,
          tracked: tracked
        },
      });
    } else {
      dispatch({
        type: FETCH_BOOKINGS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_bookings,
      });
    }
  });
};

export const updateBooking = (booking) => async (dispatch) => {

  const {
    auth,
    trackingRef,
    singleBookingRef,
    singleUserRef,
    walletHistoryRef,
    settingsRef,
    userRatingsRef
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });

  try {
    const settingsdata = await get(settingsRef);
    const settings = settingsdata.val();
    
    if (booking.status == 'PAYMENT_PENDING') {
      await update(singleBookingRef(booking.id),booking);
    }
    if (booking.status == 'NEW' || booking.status == 'ACCEPTED') {
      await update(singleBookingRef(booking.id), updateDriverQueue(booking));
    }
    if (booking.status == 'ARRIVED') {
      let dt = new Date();
      booking.driver_arrive_time = dt.getTime().toString();
      await update(singleBookingRef(booking.id),booking);
      if(booking.customer_token){
        RequestPushMsg(
          booking.customer_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.driver_near,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }
    }
    
    if (booking.status == 'STARTED') {
      let dt = new Date();
      let localString = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
      let timeString = dt.getTime();
      booking.trip_start_time = localString;
      booking.startTime = timeString;
      await update(singleBookingRef(booking.id),booking);

      const driverLocation = store.getState().gpsdata.location;
      
      if (driverLocation && driverLocation.lat && driverLocation.lng) {
        await push(trackingRef(booking.id),{
          at: new Date().getTime(),
          status: 'STARTED',
          lat: driverLocation.lat,
          lng: driverLocation.lng
        });
      }

      if(booking.customer_token){
        RequestPushMsg(
          booking.customer_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.driver_journey_msg + booking.reference,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
        }
     }

    if (booking.status == 'REACHED') {

      const driverLocation = store.getState().gpsdata.location;

      if (driverLocation && driverLocation.lat && driverLocation.lng) {
        await push(trackingRef(booking.id),{
          at: new Date().getTime(),
          status: 'REACHED',
          lat: driverLocation.lat,
          lng: driverLocation.lng
        });

        let address = await saveAddresses(booking,driverLocation);
        let bookingObj = await addActualsToBooking(booking, address, driverLocation);
        await update(singleBookingRef(booking.id),bookingObj);
      }

      if(booking.customer_token){
        RequestPushMsg(
          booking.customer_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }
    }

    if (booking.status == 'PENDING') {
      await update(singleBookingRef(booking.id),booking);
      if (booking.driver) {
        await update(singleUserRef(booking.driver), { queue: false });
      }
    }
    if (booking.status == 'PAID') {
      if(booking.booking_from_web){
        booking.status = 'COMPLETE';
      }
      await update(singleBookingRef(booking.id), booking);
      if(booking.driver && booking.driver == auth.currentUser.uid && (booking.prepaid || booking.payment_mode == 'cash' || booking.payment_mode == 'wallet')){
        await update(singleUserRef(booking.driver), { queue: false });
      }

      if(booking.customer_token){
        RequestPushMsg(
          booking.customer_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }

      if(booking.driver_token){
          RequestPushMsg(
            booking.driver_token,
            {
                title: store.getState().languagedata.defaultLanguage.notification_title,
                msg: store.getState().languagedata.defaultLanguage.success_payment,
                screen: 'BookedCab',
                params: { bookingId: booking.id }
            });
        }
      }

    if (booking.status == 'COMPLETE') {
      await update(singleBookingRef(booking.id), booking);
      if (booking.rating && booking.driver) {
        if(booking.driver_token){
          RequestPushMsg(
            booking.driver_token,
            {
                title: store.getState().languagedata.defaultLanguage.notification_title,
                msg:  store.getState().languagedata.defaultLanguage.received_rating.toString().replace("X", booking.rating.toString()),
                screen: 'BookedCab',
                params: { bookingId: booking.id }
            });
        }
        onValue(userRatingsRef(booking.driver), snapshot => {
          let ratings = snapshot.val();
          let rating;
          const ratingData = {
            user: booking.customer,
            customerName: booking.customer_name || booking.customerName || '',
            rate: Number(booking.rating),
            feedback: booking.feedback || '',
            bookingId: booking.id,
            createdAt: Date.now()
          };
          if(ratings){
            let sum = 0;
            const arr = Object.keys(ratings)
              .filter(key => key !== booking.id)
              .map(key => ratings[key]);
            for (let i = 0; i< arr.length ; i++){
              sum = sum + Number(arr[i].rate || arr[i].rating || 0)
            }
            sum = sum + ratingData.rate;
            rating = parseFloat(sum / (arr.length + 1)).toFixed(1);
          }else{
            rating = ratingData.rate;
          }
          update(singleUserRef(booking.driver),{rating: rating, ratingCount: ratings ? Object.keys({ ...ratings, [booking.id]: ratingData }).length : 1});
          update(userRatingsRef(booking.driver), { [booking.id]: ratingData });
        }, { onlyOnce: true});
      }
    }
  } catch (error) {
    console.error('updateBooking error:', error);
  }
};

// Annulation : gratuite pendant 3 min après acceptation, ensuite pénalité de 10%
// du montant de la course. Le débit/crédit des portefeuilles est fait CÔTÉ SERVEUR
// par la Cloud Function `updateBooking` (trigger sur passage à CANCELLED) — ici on
// ne fait que calculer le montant pour l'AFFICHAGE dans l'UI avant confirmation.
export const CANCELLATION_GRACE_MS = 3 * 60 * 1000;
export const CANCELLATION_FEE_RATE = 0.10;

export const getCancellationFee = (booking) => {
  if (!booking || !booking.driver || !booking.acceptedAt) return 0;
  if (['ACCEPTED', 'ARRIVED'].indexOf(booking.status) === -1) return 0;
  const elapsed = new Date().getTime() - parseFloat(booking.acceptedAt);
  if (elapsed <= CANCELLATION_GRACE_MS) return 0;
  const baseAmount = parseFloat(booking.trip_cost || booking.estimate || 0);
  if (!(baseAmount > 0)) return 0;
  return parseFloat((baseAmount * CANCELLATION_FEE_RATE).toFixed(2));
};

export const cancelBooking = (data) => async (dispatch) => {
  const {
    singleBookingRef,
    singleUserRef,
    requestedDriversRef
  } = firebase;

  dispatch({
    type: CANCEL_BOOKING,
    payload: data,
  });

  const CANCELLABLE = ['PAYMENT_PENDING', 'NEW', 'ACCEPTED', 'ARRIVED'];
  let requeued = false;

  try {
    // Transaction : empêche d'annuler une course déjà démarrée, terminée
    // ou annulée par l'autre partie au même moment.
    const result = await runTransaction(singleBookingRef(data.booking.id), (booking) => {
      if (!booking) return booking;
      if (!booking.status || CANCELLABLE.indexOf(booking.status) === -1) return;

      // Le chauffeur annule une course qu'il avait acceptée : au lieu de
      // clôturer la réservation, on la repasse en recherche (comme une
      // nouvelle demande) pour relancer automatiquement la recherche d'un
      // autre chauffeur disponible. bookingScheduler (Cloud Function, toutes
      // les minutes) reprend alors les bookings 'NEW' et les rediffuse.
      if (data.cancelledBy === 'driver' && booking.driver && ['ACCEPTED', 'ARRIVED'].indexOf(booking.status) !== -1) {
        requeued = true;
        const now = new Date().getTime();
        booking.previousDriverId = booking.driver;
        booking.previousDriverCancelledAt = now;
        booking.cancelledDriverIds = { ...(booking.cancelledDriverIds || {}), [booking.driver]: now };
        booking.status = 'NEW';
        booking.driver = null;
        booking.driver_image = null;
        booking.car_image = null;
        booking.driver_name = null;
        booking.driver_contact = null;
        booking.driver_token = null;
        booking.vehicle_number = null;
        booking.vehicleModel = null;
        booking.vehicleMake = null;
        booking.driverRating = null;
        booking.acceptedAt = null;
        booking.acceptedBy = null;
        booking.requestedDrivers = null;
        booking.driverEstimates = null;
        booking.reminderCount = null;
        booking.lastReminderTime = null;
        booking.reason = data.reason;
        booking.driverCancellationReason = data.reason;
        return booking;
      }

      booking.status = 'CANCELLED';
      booking.reason = data.reason;
      booking.cancelledBy = data.cancelledBy;
      booking.cancellationRequestedAt = new Date().getTime();
      booking.requestedDrivers = null;
      return booking;
    });

    if (!result.committed || !result.snapshot.exists()) {
      console.log('cancelBooking: aborted, booking no longer cancellable');
      return;
    }

    const booking = result.snapshot.val();
    booking.id = data.booking.id;
    const previousDriverId = requeued ? booking.previousDriverId : booking.driver;

    if (previousDriverId) {
      update(singleUserRef(previousDriverId), { queue: false }).catch(() => {});
    }
    if (!requeued) {
      remove(requestedDriversRef(booking.id)).catch(() => {});
    }

    const langData = store.getState().languagedata.defaultLanguage;
    const previousDriverToken = data.booking.driver_token;
    if (previousDriverToken) {
      RequestPushMsg(previousDriverToken, {
        title: langData.notification_title,
        msg: langData.booking_cancelled + booking.id,
        screen: requeued ? 'DriverTrips' : 'BookedCab',
        params: requeued ? {} : { bookingId: booking.id }
      });
    }
    if (booking.customer_token) {
      RequestPushMsg(booking.customer_token, {
        title: langData.notification_title,
        msg: requeued
          ? 'Votre chauffeur a annulé la course. Nous recherchons un nouveau chauffeur pour vous.'
          : langData.booking_cancelled + booking.id,
        screen: 'BookedCab',
        params: { bookingId: booking.id }
      });
    }
  } catch (error) {
    console.error('cancelBooking error:', error);
  }
};

export const updateBookingImage = (booking, imageType, imageBlob) => (dispatch) => {
  const   {
    singleBookingRef,
    bookingImageRef
  } = firebase;
  uploadBytesResumable(bookingImageRef(booking.id,imageType), imageBlob).then(() => {
    imageBlob.close()
    return getDownloadURL(bookingImageRef(booking.id,imageType))
  }).then((url) => {
    if(imageType == 'pickup_image'){
      booking.pickup_image = url;
    }
    if(imageType == 'deliver_image'){
      booking.deliver_image = url;
    }
    update(singleBookingRef(booking.id), booking);
    dispatch({
      type: UPDATE_BOOKING,
      payload: booking,
    });
  })
};

export const forceEndBooking = (booking) => async (dispatch) => {

  const {
    trackingRef,
    singleBookingRef,
    singleUserRef,
    walletHistoryRef,
    settingsRef,
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });
  
  if (booking.status == 'STARTED') {

    push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'REACHED',
      lat: booking.drop.lat,
      lng: booking.drop.lng
    });

    const end_time = new Date();
    const diff = (end_time.getTime() - parseFloat(booking.startTime)) / 1000;
    const totalTimeTaken = Math.abs(Math.round(diff));
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }

    update(singleUserRef(booking.driver),{ queue: false });

    if(booking.prepaid){

      const settingsdata = await get(settingsRef);
      const settings = settingsdata.val();

      onValue(singleUserRef(booking.driver), snapshot => {
        let walletBalance = parseFloat(snapshot.val().walletBalance);
        walletBalance = walletBalance + parseFloat(booking.driver_share);
        if(parseFloat(booking.cashPaymentAmount)>0){
          walletBalance = walletBalance - parseFloat(booking.cashPaymentAmount);
        }
        update(singleUserRef(booking.driver),{"walletBalance": parseFloat(walletBalance.toFixed(settings.decimal))});

        let details = {
          type: 'Credit',
          amount: parseFloat(booking.driver_share).toFixed(settings.decimal),
          date: new Date().getTime(),
          txRef: booking.id
        }
        push(walletHistoryRef(booking.driver),details);
        
        if(parseFloat(booking.cashPaymentAmount)>0){
          let details = {
            type: 'Debit',
            amount: booking.cashPaymentAmount,
            date: new Date().getTime(),
            txRef: booking.id
          }
          push(walletHistoryRef(booking.driver), details);
        }  
      },{onlyOnce: true});

      if(booking.customer_token){
        RequestPushMsg(
          booking.customer_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }

      if(booking.driver_token){
        RequestPushMsg(
          booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
        }
      booking.status = 'PAID';
    } else{
      booking.status = 'PENDING';
    }

    update(singleBookingRef(booking.id), booking);
  }
};
